module.exports = __webpack_public_path__ + "img/maritalStatus.7beddd60.svg";